import React, { FC, Fragment, useContext, useEffect, useState } from "react";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { FiAlertCircle } from "react-icons/fi";
import SyncOfflineDashboard from "./SyncOfflineDashboard";
import OfflineSyncModal from "./OfflineSyncModal";

import axios from "axios";
import { baseServiceUrl, urls } from "../../environment";
import toast from "react-hot-toast";
import useUserStore from "../../stores/useUserStores";
type SyncOfflinePageProps = {};
const SyncOfflinePage: FC<SyncOfflinePageProps> = (): JSX.Element => {
  const {
    token,
    setLoading,
    loading,
    isResultIsUploaded,
    setResultUploadedForOfflineCentre,
    endTimeOfExams,
    setEndTimeOfExams,
    setIsQuestionSynced,
    isQuestionSynced,
    userdetail,
    setTests,
    tests,
  } = useUserStore();
  useEffect(() => {
    if (userdetail && userdetail.userType === "TCADMIN" && isQuestionSynced) {
      (async () => {
        try {
          setLoading(true);
          const response = await axios.get(
            baseServiceUrl + urls.getAllExamUrl,
            {
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          );

          if (response.data) {
            setTests(response.data);
          }
        } catch (err: any) {
          setLoading(false);
          toast.error(
            err?.response?.data?.message || "Error encounter. Please try again."
          );
          // errornotify(
          //   err?.response?.data?.message || "Error encounter. Please try again."
          // );
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [userdetail, isQuestionSynced]);
  return (
    <Fragment>
      <OfflineSyncModal />
      <SyncOfflineDashboard tests={tests} />
    </Fragment>
  );
};

export default SyncOfflinePage;
